import { useEffect, useState } from "react";
import { ref, get, child } from "firebase/database";
import { db } from "./firebase.js";
import * as d3 from "d3";
import Session from './results/session.jsx';
import Lastitem from './results/lastitem.jsx';
import Items from './results/items.jsx';
import diamondData from '../../data/diamond_data.js'

function Results (props) {

  const session = props.session

  const [data, setData] = useState([]);
  const [prompt, setPrompt] = useState();

  const colors = {
      right: 'rgb(34, 196, 169)',
      umbrella: 'rgb(34, 196, 126)',
      close: 'rgb(225, 147, 88)',
      wrong: 'rgb(225, 116, 88)'
  }

  const handleClick = async () => {
      try {
        const dbRef = ref(db); // e.g. 'users/' or 'messages/123'
        const snapshot = await get(child(dbRef, "session_"+session));
        if (snapshot.exists()) {

          const raw = snapshot.val()
          const objects = Object.entries(raw).map(([key, value]) => ({
              id: key,
              ...value
              }));
          
          setData(objects);
        } else {
          console.log('No data available');
        }
      } catch (error) {
        console.error('Error fetching data:', error);
      }
    };

  function getLabel (id) {
      if (['queer', 'nonbinary'].includes(id)) {
          if (id === 'queer') return 'Genderqueer person'
          else if (id === 'nonbinary') return 'Nonbinary person'
      }
      else return diamondData.find(el => el.id === id).name
  }

  useEffect(() => {
    console.log(data.map(el => {return {hour: el.hour, test: el.test, general: el.general}}))
  });

  return (
    <div id="results">
      <div>
          <div 
            style={{
              display: 'flex',
              justifyContent: 'center',
              margin: '0 0 0.5em 0'
            }}
            >
            <button 
              className="button_primary" 
              onClick={handleClick}
              style={{width: 'auto'}}
              >Update data
            </button>
          </div>
          {data?.length > 0 && (
              <>
                  <Session 
                      data={data}
                      getLabel={getLabel}
                      colors={colors}
                      prompt={prompt}
                      setPrompt={setPrompt}
                  />
                  {prompt && (
                    <Items 
                        data={data}
                        getLabel={getLabel}
                        colors={colors}
                        prompt={prompt}
                    />
                  )}

              </>
          )}
      </div>
    </div>
  );
}

export default Results;
